﻿(function() {
    "use strict";

    angular.module("app").controller("PropertiesController", PropertiesController);

    PropertiesController.$inject = ["$stateParams"];

    function PropertiesController($stateParams) {
        var vm = this;
        var customerId

        vm.showDeletedView = false
        vm.$onInit = onInit;

        function onInit() {
            vm.showDeletedView = location.hash.indexOf('/deleted') > -1
            
            if (!vm.showDeletedView) {
                customerId = $stateParams.id.match(/^\d+/)[0]
            }
            vm.customerId = (customerId && customerId.length > 0) ? parseInt(customerId) : undefined
        }
    }
})();
